import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, USER_URL } from "../../constant/api";


function AdminBannerView() {
  const { id } = useParams(); // Get the banner ID from the URL
   const [banner, setBanner] = useState([]); 
   const [bannerProducts, setBannerProducts] = useState([]); // Store products related to the banner
   const token = localStorage.getItem("token");
   const navigate = useNavigate();
   // Fetch banner data by ID
   useEffect(() => {
     const fetchBannerById = async () => {
       try {
         const response = await USER_URL.get(`/products/seller/banners/${id}/`,);
         if (response.data) {
           setBanner(response.data.Data.banner); // Set the banner details
           setBannerProducts(response.data.Data.products || []); // Set the associated products
         }
       } catch (error) {
         console.error("Error fetching banner:", error.message || error);
       }
     };
     
     if (id) {
       fetchBannerById();
     }
   }, [id, token]); console.log(bannerProducts);
   
 
   if (!banner) {
     return <div className="text-center text-gray-500 mt-6">No Banner Found</div>;
   }
 
   return (
     <div>
       <div className="border-2 rounded-lg shadow-lg bg-gray-50 mt-5 p-5">
       <div className="flex justify-end  text-center ">
           <button
             onClick={() => navigate(-1)}  // Use navigate(-1) to go back
             className="flex items-center text-green-600 hover:text-green-700 font-medium text-sm focus:outline-none"
           >
 
             <span>&lt; Back to Banner List</span>
           </button>
         </div>
         <h2 className="text-green-700 text-3xl font-bold text-center mb-6">Banner</h2>
 
         {/* Banner Image and Details */}
         <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-8">
           <div>
             {/* Left side: Banner Image */}
             <div className="relative">
               <h3 className="text-xl font-semibold text-gray-800 mb-3">Banner Image</h3>
               {banner.banner ? (
                 <img
                 src={
                   banner.banner instanceof File
                     ? URL.createObjectURL(banner.banner) // Show selected logo file
                     : `${BASE_URL}${banner.banner}` // Show logo from API
                 }
                   alt="Banner"
                   className="w-full h-48 object-cover rounded-md mb-4"
                 />
               ) : (
                 <div className="w-full h-44 bg-gray-100 flex items-center justify-center rounded-md text-gray-500 mb-4">
                   No Banner Image
                 </div>
               )}
             </div>
           </div>
 
           {/* Right side: Banner Info */}
           <div>
             <div className="p-4 bg-white border rounded-lg shadow-sm mb-4">
               <span className="block text-sm font-medium text-gray-600 mb-1">Banner Title</span>
               <p className="text-lg font-semibold text-gray-800">{banner.title || "No Title"}</p>
             </div>
 
             <div className="p-4 bg-white border rounded-lg shadow-sm mb-4">
               <span className="block text-sm font-medium text-gray-600 mb-1">Start Date</span>
               <p className="text-lg font-semibold text-gray-800">{banner.start_date || "yyyy/mm/dd"}</p>
             </div>
 
             <div className="p-4 bg-white border rounded-lg shadow-sm">
               <span className="block text-sm font-medium text-gray-600 mb-1">End Date</span>
               <p className="text-lg font-semibold text-gray-800">{banner.end_date || "yyyy/mm/dd"}</p>
             </div>
           </div>
         </div>
 
         {/* Products in the Banner */}
         <div className="mt-6">
           <h4 className="text-xl font-bold mb-4">Products in Banner</h4>
           {bannerProducts.length > 0 ? (
             <div className="overflow-x-auto">
               <table className="w-full text-left">
                 <thead>
                   <tr>
                     <th className="py-2 px-2 text-green-500 text-sm font-bold">Item No</th>
                     <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Code</th>
                     <th className="py-2 px-2 text-green-500 text-sm font-bold">Product Name</th>
                     <th className="py-2 px-2 text-green-500 text-sm font-bold">Stock</th>
                     <th className="py-2 px-2 text-green-500 text-sm font-bold">Price</th>
                     <th className="py-2 px-2 text-green-500 text-sm font-bold">Image</th>
                   </tr>
                 </thead>
                 <tbody>
                   {bannerProducts.map((product, idx) => (
                     <tr key={product.id}>
                       <td className="py-2 px-2">
                         <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                           {idx + 1}
                         </div>
                       </td>
 
                       <td className="py-2 px-2">
                         <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                           {product.product_code || "N/A"}
                         </div>
                       </td>
 
                       <td className="py-2 px-2">
                         <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                           {product.product_name || "N/A"}
                         </div>
                       </td>
 
                       <td className="py-2 px-2">
                         <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                           {product.stock || "N/A"}
                         </div>
                       </td>
 
                       <td className="py-2 px-2">
                         <div className="rounded-lg border border-gray-300 px-2 py-2 text-gray-800 text-sm">
                           {product.price || "N/A"}
                         </div>
                       </td>
 
                       <td className="py-2 px-2">
                         {product.product_banner_image ? (
                           <img
                           src={
                             product.product_banner_image instanceof File
                               ? URL.createObjectURL(product.product_banner_image) // Show selected logo file
                               : `${BASE_URL}${product.product_banner_image}` // Show logo from API
                           }
                             alt={product.name || "Product Image"}
                             className="w-28 h-20 object-cover rounded"
                           />
                         ) : (
                           <div className="w-28 h-20 flex items-center justify-center border border-gray-300 rounded bg-gray-100">
                             <span className="text-xs text-gray-500">No Image</span>
                           </div>
                         )}
                       </td>
                     </tr>
                   ))}
                 </tbody>
               </table>
             </div>
           ) : (
             <p className="text-gray-500">No Products in this Banner</p>
           )}
         </div>
       </div>
     </div>
   );
 }
 

export default AdminBannerView